module.exports = __webpack_public_path__ + "poppins-v12-latin-700.woff2";